import React from 'react'

function Footer() {
  return (
    <footer
      className="bg-gray-800 text-center dark:bg-neutral-700 lg:text-left">
      <div className="p-4 text-center text-white dark:text-white">
        © 2023 Copyright: 
        <a
          className="text-white ml-2 dark:text-white"
          href="https://www.linkedin.com/in/shiwangi-kumari-5b0b3b1b7/" target='_blank'
        >Shiwangi Kumari</a>
      </div>
    </footer>
  )
}

export default Footer